import "./about.scss";

export const About = () => {
  return (
    <div className="about" id="about">
      <div className="section">
        <div className="left" data-aos="zoom-out-down">
          <h3 style={{marginBottom: "40px"}}>About me</h3>
          <p>
            I am a web developer from CDMX, México. I am passionate about IT
            focused on social causes, I am very interested in working with
            companies that make digital tools aimed at the same and that allow
            me to acquire more experience as a web developer.
          </p>
        </div>
        <div className="right" data-aos="flip-left">
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1606499407/portfolio/react_ubsxkn.png"
            alt=""
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1649199403/portfolio/redux_p0mybs.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1630429552/portfolio/typescript_f8hmml.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1606499310/portfolio/expressjslogo_ntsonv.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1652216363/portfolio/flask_k7nqer.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1606499465/portfolio/mongo_logo_whawkb.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1606502141/portfolio/node_cndlje.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1606500106/portfolio/js-logo_dkyq5w.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1606500578/portfolio/bootstrap_ez9vr6.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1606502294/portfolio/sass-logo-2_pipjuw.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1606501427/portfolio/git_zgxxxn.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
          <img
            src="https://res.cloudinary.com/robcg1102/image/upload/v1606501352/portfolio/Github_hmhwtp.png"
            alt="JS"
            className="animate__animated animate__bounce"
          />
        </div>
      </div>
    </div>
  );
};
